'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils/cn';
const DropdownShortcut = ({ className, ...props }) => {
    return _jsx("span", { className: cn('ml-auto text-body-5 opacity-60', className), ...props });
};
DropdownShortcut.displayName = 'DropdownShortcut';
export { DropdownShortcut };
